module.exports = __webpack_public_path__ + "static/media/Bankruptcy-pana.ce5c6670.png";